// @flow

import * as React from "react"
import Modal from "react-modal"
import ClassNames from "classnames"
import {t} from "i18next"

type Props = {
  +onConfirm: () => void,
  +onCancel: () => void,
  +message?: ?string,
  +okLabel?: string,
  +cancelLabel?: string,
}

type State = {
  +message: string,
  +okLabel: string,
  +cancelLabel: string,
  +disable: boolean,
}

class ConfirmModal extends React.Component<Props, State> {
  static defaultProps = {
    onConfirm: () => {},
    onCancel: () => {},
  }

  constructor(props: Props) {
    super(props)
    Modal.setAppElement("#app")
    this.state = {
      message: props.message || t("modal.confirm.message"),
      okLabel: props.okLabel || t("modal.confirm.confirm"),
      cancelLabel: props.cancelLabel || t("modal.confirm.cancel"),
      disable: false,
    }
  }

  render() {
    const {onConfirm, onCancel} = this.props
    const {message, okLabel, cancelLabel, disable} = this.state
    const className = ClassNames("modal-dialog confirm-modal", {
      "modal-sm": message.length <= 100,
      "modal-md": message.length > 100,
    })
    return (
      <Modal
        className={className}
        isOpen={true}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        onRequestClose={onCancel}
        onAfterOpen={() => {}}
        contentLabel=""
      >
        <div className="modal-content">
          <div className="modal-body">
            <p dangerouslySetInnerHTML={{__html: message}} />
            <button
              className="btn btn-primary"
              autoFocus={true}
              disabled={disable}
              onClick={() => {
                this.setState({disable: true})
                onConfirm()
              }}
            >
              {okLabel}
            </button>
            <button className="btn btn-primary" onClick={onCancel}>
              {cancelLabel}
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ConfirmModal
